interface StatusIndicatorProps {
  status: "active" | "suspended" | "paymentError";
}
const StatusIndicator = ({ status }: StatusIndicatorProps) => {
  switch (status) {
    case "active":
      return (
        <span className="w-[10px] h-[10px] bg-multicolor-green-light inline-block rounded-full" />
      );
    case "suspended":
    case "paymentError":
      return (
        <div className="w-[10px] h-[10px] bg-system-red-light inline-block rounded-full" />
      );
    default:
      return null;
  }
};

export default StatusIndicator;
